/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiChannelRulePayloadFromJSON, ApiChannelRulePayloadToJSON, } from './ApiChannelRulePayload';
export function ApiChannelGroupPayloadFromJSON(json) {
    return ApiChannelGroupPayloadFromJSONTyped(json, false);
}
export function ApiChannelGroupPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'rules': !exists(json, 'rules') ? undefined : (json['rules'].map(ApiChannelRulePayloadFromJSON)),
    };
}
export function ApiChannelGroupPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'rules': value.rules === undefined ? undefined : (value.rules.map(ApiChannelRulePayloadToJSON)),
    };
}
